import React from 'react';
import './MobileCard.css';

/*
 * Affichage "cartes" des listes sur smartphone (< 768px).
 * Le conteneur n'est visible qu'en xs (classe Bootstrap visible-xs-block) :
 * le tableau desktop correspondant doit porter la classe hidden-xs.
 */

export const MobileCardList = ({ children, empty }) => (
  <div className="visible-xs-block mobile-card-list">
    {React.Children.count(children) > 0 ? children : (empty ? <div className="mobile-card-empty">{empty}</div> : null)}
  </div>
);

export const MobileCard = ({ title, badge, subtitle, fields, actions, onClick, className, style }) => (
  <div className={'mobile-card' + (onClick ? ' mobile-card-clickable' : '') + (className ? ' ' + className : '')} style={style}>
    <div className="mobile-card-main" onClick={onClick}>
      <div className="mobile-card-header">
        <div className="mobile-card-title">{title}</div>
        {badge && <div className="mobile-card-badge">{badge}</div>}
      </div>
      {subtitle && <div className="mobile-card-subtitle">{subtitle}</div>}
      {fields && fields.filter(f => f && f.value !== undefined && f.value !== null && f.value !== '').map((f, i) =>
        <div className="mobile-card-field" key={i}>
          {f.label && <span className="mobile-card-label">{f.label}</span>}
          <span className="mobile-card-value">{f.value}</span>
        </div>
      )}
      {onClick && <i className="fa fa-chevron-right mobile-card-chevron" />}
    </div>
    {actions && <div className="mobile-card-actions">{actions}</div>}
  </div>
);
